var map = {
	"./de/btn-view.png": "WJxj",
	"./en/btn-view.png": "3GTb",
	"./es/btn-view.png": "wwPd",
	"./fr/btn-view.png": "g8IK",
	"./ja/btn-view.png": "/I+A",
	"./ko/btn-view.png": "MUb+",
	"./pt/btn-view.png": "F0DV",
	"./ru/btn-view.png": "0tn7",
	"./tc/btn-view.png": "ziWK",
	"./th/btn-view.png": "pCFj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oXqr";